import {
  requestGet,
  requestPost,
  requestPut,
  requestPatch,
  requestDelete,
  requestPostFile,
} from "../config/Api";

const name = "legal/file";

export const getLegalFiles = (params) => {
  return requestGet(name, { params });
};

export const searchLegalFiles = (params) => {
  return requestGet(`${name}/search`, { params });
};

export const getLegalFilesFailed = (params) => {
  return requestGet(`failed/file`, { params });
};

export const getTypeOperation = () => {
  return requestGet(`typeOperation`);
};

export const getDependencies = () => {
  return requestGet(`dependencies`);
};

export const getLocations = () => {
  return requestGet(`locations`);
};

export const getLegalFilesById = (id) => {
  return requestGet(`${name}/${id}`);
};

export const createLegalFile = (legalFile) => {
  return requestPost(name, legalFile);
};

export const updateLegalFile = (id, legalFile) => {
  return requestPut(`${name}/${id}`, legalFile);
};

export const deleteLegalFile = (id) => {
  return requestDelete(`${name}/${id}`);
};

export const createUploadLegalFile = (legalFile) => {
  return requestPostFile('legal/file/get/online', legalFile);
};

export const previewUploadLawyers = (legalFile) => {
  return requestPostFile('legal/file/get/online/preview-lawyers', legalFile);
};

export const chargeUploadReport = (legalFile) => {
  return requestPostFile('legal/file/report/charge', legalFile);
};

export const chargeOperationsReport = (file) => {
  return requestPostFile('legal/file/report/operations', file);
};

export const findLegalFileByCode = (code) => {
  return requestGet(`legal/file/search/${code}`);
};

export const refreshLegalFileById = (id) => {
  return requestPost(`/legal/file/refresh/${id}`);
};

export const refreshLegalFileByIdFull = (id) => {
  return requestPost(`/legal/file/refresh/full/${id}`);
};

export const associateLawsuit = (data) => {
  return requestPost("/legal/file/associate/lawsuit", data);
};

export const createUploadAportes = (legalFile) => {
  return requestPostFile('attachments/legal/file/upload/aportes', legalFile);
};

export const uploadMultiplesAttachmentsAportes = (data) => {
  return requestPostFile("/attachments/legal/file/upload/multiple/attachments/aportes", data);
};

export const createLegalFileManual = (data) => {
  return requestPost("/legal/file/create/manual", data);
};

export const changeLegalFileStage = (id, legalFileStageId) => {
  return requestPatch(`${name}/${id}/stage`, {
    legal_file_stage_id: legalFileStageId,
  });
};

// Devuelve la etapa a modo automático (la vuelve a recalcular el sistema).
export const releaseLegalFileStage = (id) => {
  return requestPatch(`${name}/${id}/stage`, { release: true });
};

// Corrección manual del tipo de expediente (municipality | external).
export const changeLegalFileType = (id, type) => {
  return requestPatch(`${name}/${id}/type`, { type });
};
